<template>
  <div class="main">
    <heading></heading>
    <front></front>
    <footing></footing>
    <!--<router-view></router-view>-->
  </div>
</template>

<script>
  import Heading from '@/components/dn/Simple/Heading';
  import Footing from '@/components/dn/Footing';
  import Front from '@/components/views/Front';

  export default {
    components: {
      Heading,
      Footing,
      Front,
    }
  }
</script>

<style lang="scss">
  @import '~bootstrap-reboot';
  @import 'scss/core';
  @import 'scss/dn/core';
</style>